import { RefreshCw, ArrowDownToLine, ArrowUpFromLine } from "lucide-react";
import Deposit from "../../assets/icons/Deposit.svg?react";
import Withdraw from "../../assets/icons/Withdraw.svg?react";
import BgLatto from "../../assets/images/bg-latto.jpg";
import { useState, useEffect } from "react";
import WithdrawPopup from "../../components/Popup/WithdrawPopup";
import DepositPopupQR from "../../components/Popup/DepositPopupQR";
import DepositPopup from "../../components/Popup/DepositPopup";
import { useAuth } from "../../context/AuthContext";
import { useWebSocket } from '../../context/WebSocketContext';
import { settingsApi } from "../../api/settings";

export default function BalanceCard({ balance }) {
  const [showWithDraw, setShowWithDraw] = useState(false);
  const [showDepositQr, setShowDepositQr] = useState(false);
  const [showDeposit, setShowDeposit] = useState(false);
  const { walletBalance, resetPaymentStatus, refreshWalletBalance } = useWebSocket();
  const { tokens, user } = useAuth();
  const [manualDepositEnabled, setManualDepositEnabled] = useState(false);

  useEffect(() => {
    const fetchManualDepositEnabled = async () => {
      const response = await settingsApi.getSettingsByKey(tokens.access.token, "manualDepositEnabled");
      console.log(response);
      setManualDepositEnabled(response.data.value === "true");
    };
    fetchManualDepositEnabled();

  }, [tokens.access.token, user.id]);

  // Listen for wallet refresh events
  useEffect(() => {
    const handleWalletRefresh = async () => {
      refreshWalletBalance();
    };

    window.addEventListener('walletRefresh', handleWalletRefresh);
    
    return () => {
      window.removeEventListener('walletRefresh', handleWalletRefresh);
    };
  }, [refreshWalletBalance]);

  const formatBalance = (amount) => {
    if (!amount) return '0.00';
    return parseFloat(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true
    });
  };
  
  let displayBalance = walletBalance || balance;
  displayBalance = formatBalance(parseFloat(displayBalance));

  const handleQrDepositClick = () => {
    resetPaymentStatus(); // Reset payment status before showing QR deposit
    setShowDepositQr(true);
  };

  return (
    <>
      <div
        className="mx-1 rounded-[25px] p-4 max-xs:p-3 text-center"
        style={{
          backgroundImage: `url('${BgLatto}'), linear-gradient(108.9deg, rgba(14, 100, 209, 0.6) 0%, rgba(30, 66, 154, 0.6) 100.79%)`,
          backgroundBlendMode: "soft-light", // Ensures the gradient and image blend nicely
          backgroundSize: "cover", // Ensures the image covers the card
          backgroundPosition: "center", // Centers the image
        }}
      >
        <p className="text-white mb-2 text-sm font-normal max-xs:text-xs ">
          Available Balance
        </p>
        <div className="flex items-center justify-center gap-2 mb-4 text-6xl font-semibold text-[#FBD115] max-xs:text-5xl ">
          <span
            className={`${
              displayBalance.toString().length > 6 ? "text-4xl max-xs:text-3xl" : ""
            }`}
          >
            ₱ {displayBalance}
          </span>
          <button 
            className="ml-2 hover:scale-110 transition-transform duration-200"
            onClick={() => refreshWalletBalance()}
          >
            <RefreshCw className="w-6 h-6 text-white" />
          </button>
        </div>
        <div className="grid grid-cols-2 gap-4 max-xs:text-sm">
          <button
            className="flex items-center justify-center gap-2 bg-white rounded-full py-2 px-4 max-xs:py-1.5 text-[#0E64D1] font-medium"
            onClick={handleQrDepositClick}
          >
            <Deposit className=" w-[22px] h-[22px] max-xs:w-[18px] max-xs:h-[18px]" />
            Deposit
          </button>
          <button
            className="flex items-center justify-center gap-2 bg-[#0E64D1] rounded-full py-2 px-4  max-xs:py-1.5 text-white font-medium"
            onClick={() => setShowWithDraw(true)}
          >
            <Withdraw className=" w-[22px] h-[22px] max-xs:w-[18px] max-xs:h-[18px]" />
            Withdraw
          </button>
        </div>
          
        {user.roleId !== 1 && manualDepositEnabled && (
        <div className="grid grid-cols-1 gap-4 max-xs:text-sm mt-4">
          <button
            className="bg-[#0E64D1] text-white flex items-center justify-center gap-2 rounded-full py-2 px-4 max-xs:py-1.5 font-medium"
            onClick={() => setShowDeposit(true)}
          >
            <Deposit className=" w-[22px] h-[22px] max-xs:w-[18px] max-xs:h-[18px]" />
            Manual Deposit
          </button>
        </div>
        )}
      </div>

      <DepositPopup
        isOpen={showDeposit}
        onClose={() => setShowDeposit(false)}
        currentBalance={displayBalance}
      />

      <DepositPopupQR
        isOpen={showDepositQr}
        onClose={() => setShowDepositQr(false)}
        currentBalance={displayBalance}
      />

      <WithdrawPopup
        isOpen={showWithDraw}
        onClose={() => setShowWithDraw(false)}
        currentBalance={displayBalance}
        defaultPaymentMethod={{
          type: "GCASH",
          accountNumber: "09187914980",
        }}
      />
    </>
  );
}
